import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 0,
    role: "status",
    "aria-live": "polite"
};
const _hoisted_2 = {
    key: 1,
    class: "alert alert-danger",
    role: "alert"
};
const _hoisted_3 = {
    key: 2,
    class: "row g-4"
};
const _hoisted_4 = { class: "col-lg-8" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-md-6 mb-3" };
const _hoisted_8 = { class: "col-md-6 mb-3" };
const _hoisted_9 = { class: "mb-4" };
const _hoisted_10 = { class: "mb-3" };
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "mb-3" };
const _hoisted_13 = { class: "mb-3" };
const _hoisted_14 = {
    class: "catalog-access-summary mb-3",
    role: "status"
};
const _hoisted_15 = {
    key: 0,
    class: "mt-1"
};
const _hoisted_16 = {
    key: 1,
    class: "mt-1"
};
const _hoisted_17 = {
    key: 0,
    class: "alert alert-danger",
    role: "alert"
};
const _hoisted_18 = {
    key: 1,
    class: "alert alert-success",
    role: "status"
};
const _hoisted_19 = { class: "col-lg-4" };
const _hoisted_20 = ["disabled"];
const _hoisted_21 = { class: "mb-3" };
const _hoisted_22 = { class: "mb-3" };
const _hoisted_23 = {
    key: 0,
    class: "alert alert-danger",
    role: "alert"
};
const _hoisted_24 = {
    key: 1,
    class: "alert alert-success",
    role: "status"
};
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import MultiSelect from "primevue/multiselect";
import UserHandler from "@/api/User";
import User from "@/module/User";
import { userErrorMessage } from "./errorMessage";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdminUserForm',
    setup(__props) {
        const userId = Number(useRoute().params.id);
        const user = ref({
            id: "",
            name: "",
            email: "",
            instanceId: 0,
            groups: [],
            catalogGroups: [],
            catalogIds: [],
        });
        const options = ref({
            groups: [],
            catalogGroups: [],
            catalogs: [],
            instances: [],
        });
        const loading = ref(true);
        const loadError = ref("");
        const saving = ref(false);
        const saveError = ref("");
        const saveSuccess = ref(false);
        const password = ref("");
        const confirmation = ref("");
        const savingPassword = ref(false);
        const passwordError = ref("");
        const passwordSuccess = ref(false);
        watch(user, () => (saveSuccess.value = false), { deep: true });
        const roleOptions = computed(() => options.value.groups.map((group) => ({ ...group, id: Number(group.id) })));
        const catalogGroupOptions = computed(() => options.value.catalogGroups.map((group) => ({
            ...group,
            id: Number(group.id),
        })));
        const catalogOptions = computed(() => options.value.catalogs
            .filter((catalog) => Number(catalog.instanceId) === user.value.instanceId)
            .map((catalog) => ({
            ...catalog,
            id: Number(catalog.id),
            label: `${catalog.name} (${catalog.externalId})`,
        })));
        const isAdministrator = computed(() => roleOptions.value.some((group) => group.code === "global-admin" && user.value.groups.includes(group.id)));
        const availableCatalogs = computed(() => {
            const ids = new Set(user.value.catalogIds);
            for (const group of catalogGroupOptions.value) {
                if (user.value.catalogGroups.includes(group.id)) {
                    group.catalogIds.forEach((id) => ids.add(Number(id)));
                }
            }
            return catalogOptions.value.filter((catalog) => ids.has(catalog.id));
        });
        function changeInstance() {
            user.value.catalogIds = user.value.catalogIds.filter((id) => catalogOptions.value.some((catalog) => catalog.id === id));
            saveSuccess.value = false;
        }
        async function loadUser() {
            loading.value = true;
            loadError.value = "";
            try {
                const [profile, access] = await Promise.all([
                    UserHandler.getUser(userId),
                    UserHandler.getAccessOptions(),
                ]);
                const data = profile.getResponse();
                options.value = access.getResponse();
                user.value = {
                    id: data.id,
                    name: data.name,
                    email: data.email,
                    instanceId: Number(data.instanceId),
                    groups: data.groups.map(Number),
                    catalogGroups: data.catalogGroups.map(Number),
                    catalogIds: data.catalogIds.map(Number),
                };
            }
            catch (err) {
                loadError.value = userErrorMessage(err);
            }
            finally {
                loading.value = false;
            }
        }
        async function saveUser() {
            if (saving.value)
                return;
            saving.value = true;
            saveError.value = "";
            saveSuccess.value = false;
            try {
                await UserHandler.updateUser(userId, {
                    name: user.value.name,
                    email: user.value.email,
                    instanceId: user.value.instanceId,
                    groups: user.value.groups,
                    catalogGroups: user.value.catalogGroups,
                    catalogIds: user.value.catalogIds,
                });
                saveSuccess.value = true;
                if (Number(User.getMe().id) === userId) {
                    const me = await UserHandler.getMe();
                    sessionStorage.setItem("me", JSON.stringify(me.getResponse()));
                    window.location.assign(User.isAdmin() ? "/admin/users" : "/");
                }
            }
            catch (err) {
                saveError.value = userErrorMessage(err);
            }
            finally {
                saving.value = false;
            }
        }
        async function changePassword() {
            if (savingPassword.value)
                return;
            passwordError.value = "";
            passwordSuccess.value = false;
            if (password.value !== confirmation.value) {
                passwordError.value = "Пароли не совпадают.";
                return;
            }
            savingPassword.value = true;
            try {
                await UserHandler.updatePassword(userId, password.value, confirmation.value);
                password.value = "";
                confirmation.value = "";
                passwordSuccess.value = true;
            }
            catch (err) {
                passwordError.value = userErrorMessage(err);
            }
            finally {
                savingPassword.value = false;
            }
        }
        onMounted(loadUser);
        return (_ctx, _cache) => {
            const _component_Button = _resolveComponent("Button");
            return (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Загрузка пользователя… "))
                : (loadError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("p", null, _toDisplayString(loadError.value), 1),
                        _createVNode(_component_Button, {
                            label: "Повторить загрузку",
                            icon: "pi pi-refresh",
                            onClick: loadUser
                        })
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(saveUser, ["prevent"])
                            }, [
                                _createElementVNode("fieldset", { disabled: saving.value }, [
                                    _cache[19] || (_cache[19] = _createElementVNode("legend", { class: "h5 mb-3" }, "Учётная запись", -1)),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _cache[10] || (_cache[10] = _createElementVNode("label", {
                                                for: "admin-user-name",
                                                class: "form-label"
                                            }, "Имя", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                id: "admin-user-name",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((user.value.name) = $event)),
                                                class: "form-control",
                                                required: "",
                                                maxlength: "255"
                                            }, null, 512), [
                                                [
                                                    _vModelText,
                                                    user.value.name,
                                                    void 0,
                                                    { trim: true }
                                                ]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_8, [
                                            _cache[11] || (_cache[11] = _createElementVNode("label", {
                                                for: "admin-user-email",
                                                class: "form-label"
                                            }, "Email", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                id: "admin-user-email",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((user.value.email) = $event)),
                                                type: "email",
                                                class: "form-control",
                                                required: "",
                                                maxlength: "255"
                                            }, null, 512), [
                                                [
                                                    _vModelText,
                                                    user.value.email,
                                                    void 0,
                                                    { trim: true }
                                                ]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _cache[12] || (_cache[12] = _createElementVNode("label", {
                                            for: "admin-user-groups",
                                            class: "form-label"
                                        }, "Группы пользователя", -1)),
                                        _createVNode(_unref(MultiSelect), {
                                            inputId: "admin-user-groups",
                                            modelValue: user.value.groups,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((user.value.groups) = $event)),
                                            options: roleOptions.value,
                                            optionLabel: "name",
                                            optionValue: "id",
                                            filter: "",
                                            display: "chip",
                                            class: "w-full",
                                            placeholder: "Выберите группы",
                                            disabled: saving.value
                                        }, null, 8, ["modelValue", "options", "disabled"]),
                                        _cache[13] || (_cache[13] = _createElementVNode("small", { class: "text-secondary d-block mt-2" }, "Группы определяют доступ к разделам интерфейса. Группа global-admin даёт права администратора.", -1))
                                    ]),
                                    _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "h5 mb-3" }, "Доступ к каталогам", -1)),
                                    _createElementVNode("div", _hoisted_10, [
                                        _cache[15] || (_cache[15] = _createElementVNode("label", {
                                            for: "admin-user-instance",
                                            class: "form-label"
                                        }, "Экземпляр планнера", -1)),
                                        _withDirectives(_createElementVNode("select", {
                                            id: "admin-user-instance",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((user.value.instanceId) = $event)),
                                            class: "form-select",
                                            onChange: changeInstance
                                        }, [
                                            _cache[14] || (_cache[14] = _createElementVNode("option", { value: 0 }, "Не назначен", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value.instances, (instance) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: instance.id,
                                                    value: Number(instance.id)
                                                }, _toDisplayString(instance.name), 9, _hoisted_11));
                                            }), 128))
                                        ], 544), [
                                            [
                                                _vModelSelect,
                                                user.value.instanceId,
                                                void 0,
                                                { number: true }
                                            ]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _cache[16] || (_cache[16] = _createElementVNode("label", {
                                            for: "admin-user-catalog-groups",
                                            class: "form-label"
                                        }, "Группы каталогов", -1)),
                                        _createVNode(_unref(MultiSelect), {
                                            inputId: "admin-user-catalog-groups",
                                            modelValue: user.value.catalogGroups,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((user.value.catalogGroups) = $event)),
                                            options: catalogGroupOptions.value,
                                            optionLabel: "title",
                                            optionValue: "id",
                                            filter: "",
                                            display: "chip",
                                            class: "w-full",
                                            placeholder: "Выберите группы каталогов",
                                            disabled: saving.value
                                        }, null, 8, ["modelValue", "options", "disabled"])
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                        _cache[17] || (_cache[17] = _createElementVNode("label", {
                                            for: "admin-user-catalogs",
                                            class: "form-label"
                                        }, "Отдельные каталоги", -1)),
                                        _createVNode(_unref(MultiSelect), {
                                            inputId: "admin-user-catalogs",
                                            modelValue: user.value.catalogIds,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((user.value.catalogIds) = $event)),
                                            options: catalogOptions.value,
                                            optionLabel: "label",
                                            optionValue: "id",
                                            filter: "",
                                            display: "chip",
                                            class: "w-full",
                                            placeholder: "Выберите каталоги",
                                            disabled: saving.value || !user.value.instanceId
                                        }, null, 8, ["modelValue", "options", "disabled"]),
                                        _cache[18] || (_cache[18] = _createElementVNode("small", { class: "text-secondary d-block mt-2" }, "Доступ из групп и отдельных каталогов суммируется. Чтобы закрыть каталог из группы, снимите соответствующую группу.", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        (isAdministrator.value)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode("Администратору доступны все каталоги выбранного экземпляра.")
                                            ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createElementVNode("div", null, "Доступно каталогов: " + _toDisplayString(availableCatalogs.value.length), 1),
                                                (availableCatalogs.value.length)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(availableCatalogs.value.map((catalog) => catalog.name).join(", ")), 1))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_16, " Выберите экземпляр и назначьте группы или отдельные каталоги. "))
                                            ], 64))
                                    ]),
                                    (saveError.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(saveError.value), 1))
                                        : _createCommentVNode("", true),
                                    (saveSuccess.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Изменения сохранены. "))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_Button, {
                                        type: "submit",
                                        label: "Сохранить изменения",
                                        icon: "pi pi-check",
                                        loading: saving.value,
                                        disabled: saving.value
                                    }, null, 8, ["loading", "disabled"])
                                ], 8, _hoisted_5)
                            ], 32)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(changePassword, ["prevent"])
                            }, [
                                _createElementVNode("fieldset", { disabled: savingPassword.value }, [
                                    _cache[23] || (_cache[23] = _createElementVNode("legend", { class: "h5 mb-3" }, "Смена пароля", -1)),
                                    _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-secondary" }, " Задайте новый пароль пользователю. Минимум 8 символов. ", -1)),
                                    _createElementVNode("div", _hoisted_21, [
                                        _cache[21] || (_cache[21] = _createElementVNode("label", {
                                            for: "admin-user-password",
                                            class: "form-label"
                                        }, "Новый пароль", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            id: "admin-user-password",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((password).value = $event)),
                                            onInput: _cache[7] || (_cache[7] = ($event) => (passwordSuccess.value = false)),
                                            type: "password",
                                            autocomplete: "new-password",
                                            class: "form-control",
                                            required: "",
                                            minlength: "8",
                                            maxlength: "255"
                                        }, null, 544), [
                                            [_vModelText, password.value]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                        _cache[22] || (_cache[22] = _createElementVNode("label", {
                                            for: "admin-user-password-confirmation",
                                            class: "form-label"
                                        }, "Повторите пароль", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            id: "admin-user-password-confirmation",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((confirmation).value = $event)),
                                            onInput: _cache[9] || (_cache[9] = ($event) => (passwordSuccess.value = false)),
                                            type: "password",
                                            autocomplete: "new-password",
                                            class: "form-control",
                                            required: "",
                                            minlength: "8",
                                            maxlength: "255"
                                        }, null, 544), [
                                            [_vModelText, confirmation.value]
                                        ])
                                    ]),
                                    (passwordError.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(passwordError.value), 1))
                                        : _createCommentVNode("", true),
                                    (passwordSuccess.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, " Пароль изменён. "))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_Button, {
                                        type: "submit",
                                        label: "Изменить пароль",
                                        icon: "pi pi-key",
                                        class: "p-button-outlined",
                                        loading: savingPassword.value,
                                        disabled: savingPassword.value
                                    }, null, 8, ["loading", "disabled"])
                                ], 8, _hoisted_20)
                            ], 32)
                        ])
                    ]));
        };
    }
});
